import axios from "axios";
var ipRangeCheck = require("ip-range-check");

const interaction = {
  data: function() {
    return {
      mxUserIP: "notSet",
      mxListIP: ["65.93.70.0/24", "192.197.178.0/24", "50.101.56.177/24"],
      mxUserDenied: false,
      mxUserDate:{
       label:"UserDate",
       relationship: "INTERACT_WITH_CONTEXT",
       properties: {
        date: "date",
       }       
      },
      mxIndustry: {
        label: "Industry",
        relationship: "INTERACT_WITH_CONTEXT",
        properties: {
          naics_code: "naics_code",
          naics_keywords: "naics_keywords",
          naics_keywords_fr: "naics_keywords_fr",
          title: "title",
          title_fr: "title_fr"
        }
      },
      mxInteraction: {
        label: "Interaction"
      },
      mxKeywordNotFound: {
        label: "UserKeywordNotFound",
        relationship: "INTERACT_WITH_CONTEXT",
        properties: {
          keyword: "keyword",
          timestamp: "timestamp",
          timestamp_readable: "timestamp_readable"
        }
      },
      mxKeywordFound: {
        label: "UserKeywordFound",
        relationship: "INTERACT_WITH_CONTEXT",
        properties: {
          keyword: "keyword",
          code: "selection Code",
          code_name: "selection Code Name",
          timestamp: "timestamp",
          timestamp_readable: "timestamp_readable"
        }
      },
      mxLocation: {
        label: "Location",
        relationship: "INTERACT_WITH_CONTEXT",
        properties: {
          sgc_longitude: "sgc_longitude",
          title_fr: "title_fr",
          title: "title",
          sgc_code: "sgc_code",
          sgc_level: "sgc_level",
          sgc_latitude: "sgc_latitude"
        }
      }, //location
      mxPermit: {
        label: "Permits",
        relationship: "INTERACT_VIEWED",
        properties: {
          pid: "pid",
          title: "title",
          title_fr: "title_fr",
          owner: "owner"
        }
      }, //Permit
      mxActivityGroupSelected: {
        label: "ActivityCategorySelected",
        relationship: "INTERACT_WITH_CONTEXT",
        properties: {
          id: "id",
          title: "title",
          title_fr: "title_fr",
          activitiesID: "activitiesID",
          key: "key"
        }
      } //Group
    };
  }, //end data
  mounted: function() {
    if (process.env.VUE_APP_TURN_ON_IP_FILTERING === "true") {
      if (sessionStorage.getItem("userIP") === null) {
        try {
          axios
            .get("https://cms.bizpal-perle.ca/get_ip/")
            .then(response => {
              this.mxUserIP = response.data;
              sessionStorage.setItem("userIP", this.mxUserIP);
              this.mxCheckIfIPIsDeny(response.data);
            })
            .catch(error => {
              error;
            });
        } catch (error) {
          error;
        }
      } else {
        this.mxUserIP = sessionStorage.getItem("userIP");
        this.mxUserDenied = sessionStorage.getItem("userDenied")
          ? sessionStorage.getItem("userDenied")
          : false;
      }
    } else {
      this.mxUserDenied = false;
    }
  },
  computed: {},
  methods: {
    mxCheckIfIPIsDeny: function(userIP) {
      for (var i = 0; i < this.mxListIP.length; i++) {
        var IP = this.mxListIP[i];

        if (ipRangeCheck(userIP.trim(), IP.trim())) {
          this.mxUserDenied = true;
          sessionStorage.setItem("userDenied", true);
          break;
        }
      }
    },
    mxSaveInteraction: function(url, user, pwd, statements) {
      if (!this.mxUserDenied) {
        try{
        axios({
          method: "post",
          url: url,
          auth: {
            username: user,
            password: pwd
          },
          data: {
            statements: statements
          }
        }).catch(function(err){
           console.log(err)
        });
      }catch(error){
        console.log(error)
      }
      } else {
        //enif
        console.log("Interaction Denied");
        console.log(this.mxUserIP);
      }
    }, //saveInteraction
    mxGetTimeStamp: function(format = false) {
      let currentDate = new Date();
      return !format
        ? currentDate.getTime()
        : `${currentDate.getFullYear()}-${currentDate.getMonth() +
            1}-${currentDate.getDate()}`;
    },
    mxCreateNodeStatement: function(
      nodeVariable,
      nodeLabel,
      properties,
      createTimestamp = true
    ) {
      // add properties for timestamps
      if (createTimestamp) {
        properties.timestamp = this.mxGetTimeStamp();
        properties.timestamp_readable = this.mxGetTimeStamp(true);
      }
      let statement = {
        statement: `CREATE (${nodeVariable}:${nodeLabel} {props})`,
        parameters: {
          props: properties
        }
      };
      return statement;
    }, //createNode

    // special case of Creating using Merge ... merge statement can't pass parameters
    mxCreateMergeNodeStatement: function(
      nodeVariable,
      nodeLabel,
      PermitPoperties
    ) {
      let statement = {
        statement: `MERGE (${nodeVariable}:${nodeLabel} ${PermitPoperties}) ON CREATE SET ${nodeVariable}.need_to_update = true`
      };
      return statement;
    },

    // Permit case of Creating using Merge ... merge statement can't pass parameters
    mxCreateMergePermitStatement: function(nodeVariable, nodeLabel, permit) {
      let statement = {
        statement: `MERGE (${nodeVariable}:${nodeLabel}  {pid:"${permit.id}"}) ON CREATE SET ${nodeVariable}.need_to_update = true, ${nodeVariable}.title = "${permit.title}"`
      };
      return statement;
    },
    // dateAsString format = yyyy-MM-DD or yyyy-m-d
    mxCreateDateMergeRelationshipDate: function(interactionKey,dateAsString){
      let statement = {
           statement: `match (n:${this.mxInteraction.label} {key:'${interactionKey}'})
                       MERGE (d:${this.mxUserDate.label} {${this.mxUserDate.properties.date}:date('${dateAsString}')}) 
           MERGE (d)-[:INTERACT_WITH_CONTEXT]->(n)`
      }
       return statement;
    },
    mxCreateInteractionRelationshipStatement: function(
      interactionLabel,
      interactionKey,
      relationshipLabel,
      nodeLabel,
      nodeProperty,
      propertyValues, // array of String or integer
      isPropertyTypeString = true
    ) {
      if (Array.isArray(propertyValues)) {
        let realValues = isPropertyTypeString
          ? propertyValues.map(function(element) {
              return `'${element}'`;
            }) //neo4j required string to be in quote
          : propertyValues.map(function(element) {
              return parseInt(element);
            });

        let statement = {
          statement: `MATCH (inter:${interactionLabel} {key:'${interactionKey}'})
        MATCH (n:${nodeLabel}) where n.${nodeProperty} in [${realValues.toString()}] 
        CREATE (inter)-[:${relationshipLabel}]->(n)`
        };
        return statement;
      } else {
        console.log(
          "error: createInteractionRelationshipStatement() - propertyValues as to be of type Array"
        );
        return "error: createInteractionRelationshipStatement() - propertyValues as to be of type Array";
      } //else
    }, //createNode

    mxGetDefaultInteractionProp: function(
      lang,
      productName,
      sgcObj = {},
      naicsObj = {}
    ) {
      let props = {
        browser: this.mxGetBrowser(),
        fulluseragent: navigator.userAgent,
        hostname: location.hostname,
        key: this.mxGetUniqueKey(),
        language: lang,
        mobile: this.mxGetMobileVersion(),
        OS: this.mxGetOS(),
        product: productName,
        screensize: screen.width + "x" + screen.height,
        session: this.mxGetInteractionSession(),
        sgc_code: sgcObj.code,
        sgc_name: sgcObj.name,
        naics_code: naicsObj.code,
        naics_name: naicsObj.name
      };

      return props;
    }, //getInteractionProp
    mxGetBrowser: function() {
      let browserName = navigator.appName;
      var nAgt = navigator.userAgent;
      var nameOffset, verOffset;
      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browserName = nAgt.substring(nameOffset, verOffset);
      }

      return browserName;
    }, //end
    mxGetMobileVersion: function() {
      var mobile = "not applicable";
      if (navigator.userAgent.match(/Android/i)) {
        mobile = "Android";
      } else if (navigator.userAgent.match(/BlackBerry/i)) {
        mobile = "BlackBerry";
      } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        mobile = "iPhone";
      } else if (navigator.userAgent.match(/Opera Mini/i)) {
        mobile = "Opera Mini";
      } else if (navigator.userAgent.match(/IEMobile/i)) {
        mobile = "Windows";
      }
      return mobile;
    }, //end
    mxGetOS: function() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }
      return os;
    }, //end
    mxGetUniqueKey: function() {
      var dateTime = Date.now();
      var timestamp = Math.floor(dateTime / 1000);
      var uniqueID = `id-${timestamp}${Math.random()
        .toString(36)
        .substr(2, 16)}`;
      return uniqueID;
    }, //getUnique,

    mxGetInteractionSession: function() {
      if (sessionStorage.getItem("interactionSession")) {
        return sessionStorage.getItem("interactionSession");
      } else {
        var dateTime = Date.now();
        var timestamp = Math.floor(dateTime / 1000);
        var uniqueID = `session-${timestamp}${Math.random()
          .toString(36)
          .substr(2, 16)}`;
        sessionStorage.setItem("interactionSession", uniqueID);
        return uniqueID;
      }
    } //getInteraction
  } //methods
};

export default interaction;
